Retorna os dados básicos da organização autenticada pela credencial atual.

Use este endpoint para confirmar rapidamente qual organização a integração está acessando.

<ApiCodeExamples exampleId="metaTenant" />

<ApiResponseExamples exampleId="metaTenant" />

## Query parameters

Este endpoint não aceita query parameters.

## Resposta `200`

- `id` (`uuid`): identificador da organização autenticada.
- `name` (`string`): nome exibido da organização.
- `email` (`string`, formato email): email principal configurado para a organização.
- `is_active` (`boolean`): indica se a organização está ativa no produto.
  Valores possíveis:
  `true`, `false`

## Erros esperados

- `401 Unauthorized`: token inválido, expirado, revogado, ausente ou bloqueado por IP.
- `403 Forbidden`: a credencial autenticou, mas não possui o escopo exigido para a operação.
- `429 Too Many Requests`: a credencial excedeu o limite permitido na janela atual.

## Quando usar este endpoint

- validar rapidamente qual organização a credencial autenticou;
- conferir se a integração está apontando para a organização correta;
- fazer smoke test inicial depois de criar ou rotacionar uma credencial.
